import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class CellHeader extends PureComponent {
  render() {
    const { children, className, ...others } = this.props;
    const cls = classNames({
      "weui-cell__hd": true
    }, className);

    return <div className={ cls } { ...others }>{ children }</div>;
  }
}
